if (typeof debounce === 'undefined') {
  function debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
  window.debounce = debounce
}
/**
 *  @class
 *  @function ThemeHeader
 */
if (!customElements.get('theme-header')) {
  class ThemeHeader extends HTMLElement {
    connectedCallback() {
      this.header_section = document.querySelector('.header-section');
      this.menu = this.querySelector('#mobile-menu');
      this.toggle = this.querySelector('.mobile-toggle-wrapper');

      document.addEventListener('keyup', (e) => {
        if (e.code) {
          if (e.code.toUpperCase() === 'ESCAPE') {
            this.toggle.removeAttribute('open');
            this.toggle.classList.remove('active');
          }
        }
      });
      // official
      if (Array.prototype.some.call(document.head.querySelectorAll('link[rel="canonical"]'), v => /www\.elegoo\.com/.test(v.href))) {
        this.addEventListener('click', (e) => {
          const suggestedStore = sessionStorage.getItem('suggested-store')
          /**
           * @param {HTMLElement} el 
           * @param {string} selector 
           * @returns 
           */
          const traverse = (el, selector) => {
            const found = Array.from(el.parentElement.querySelectorAll(selector)).find(v => v === el)
            if (!found) {
              if (el !== e.currentTarget) {
                return traverse(el.parentElement, selector)
              }
              return null
            }
            return found
          }
          const el = e.target
          let href = ''
          // media-grid compatible
          const mediaGridItem = traverse(el, '.media-grid--item')
          if (mediaGridItem && mediaGridItem.getAttribute('onclick')) {
            href = mediaGridItem.getAttribute('onclick').replace(/.*\.href=(\'|\")(.*?)(\'|\")$/, '$2')
          }
          const anchor = traverse(el, 'a')
          if (anchor) {
            href = anchor.getAttribute('href')
          }
          if (suggestedStore && /^\/(products|collections)\//.test(href)) {
            e.preventDefault()
            const suggested = new URL(suggestedStore)
            suggested.pathname = href
            window.location.href = suggested.toString()
              .replace(/(utm_source=)\w*/, '$1officialmenu')
          }
        })
      }
      if (this.classList.contains('header-sticky--active')) {
        document.body.classList.add('header-sticky--active');
      }
      this.toggle.querySelector('.mobile-toggle').addEventListener('click', (e) => {
        if (this.toggle.classList.contains('active')) {
          e.preventDefault();
          this.toggle.querySelector('nav').innerHTML = ''
          document.body.classList.remove('overflow-hidden');
          this.toggle.classList.remove('active');
          this.closeAnimation(this.toggle);
        } else {
          this.toggle.querySelector('nav').appendChild(this.toggle.querySelector('template[name="mobile-menu-drawer--content"]').content.cloneNode(true))
          document.body.classList.add('overflow-hidden');
          setTimeout(() => {
            this.toggle.classList.add('active');
          });
        }
      });

      // Sticky Header Class
      window.addEventListener('scroll', this.setStickyClass, {
        passive: true
      });

      // Mobile Menu offset
      window.addEventListener('scroll', this.setHeaderOffset, {
        passive: true
      });
      window.addEventListener('scroll', this.setHeaderHeight, {
        passive: true
      });
      window.addEventListener('scroll', this.setSecondaryHeight, {
        passive: true
      });

      if (document.querySelector('.announcement-bar-section')) {
        window.addEventListener('scroll', this.setAnnouncementHeight, {
          passive: true
        });
        window.dispatchEvent(new Event('resize'));
      }

      window.dispatchEvent(new Event('scroll'));

      // Mobile Navigation transparent header support.
      setTimeout(() => {

        this.mobile_nav = document.querySelector('.header-mobile-navigation');

        if (this.mobile_nav && this.classList.contains('transparent--true')) {
          this.mobile_nav.classList.add('is-fixed');
        }
      }, 100);
      // Buttons.
      this.menu.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
      this.menu.querySelectorAll('.parent-link-back--button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
    }
    setStickyClass = debounce(() => {
      if (this.classList.contains('header-sticky--active')) {
        let offset = parseInt(this.getBoundingClientRect().top, 10) + document.documentElement.scrollTop;
        this.classList.toggle('is-sticky', window.scrollY >= offset && window.scrollY > 0);
      }
    }, 50)
    setAnnouncementHeight = debounce(() => {
      const a_bar = document.querySelector('.announcement-bar-section');
      let h = a_bar.clientHeight;
      document.documentElement.style.setProperty('--announcement-height', h + 'px');
    }, 50)
    setHeaderOffset = debounce(() => {
      let h = this.header_section.getBoundingClientRect().top;
      document.documentElement.style.setProperty('--header-offset', h + 'px');
    }, 50)
    setSecondaryHeight = debounce(() => {
      const secondary = document.querySelector('.header-secondary-menu-section');
      const secondaryHeight = secondary ? secondary.clientHeight : 0;
      document.documentElement.style.setProperty('--secondary-header-height', secondaryHeight + 'px');
    }, 50)
    setHeaderHeight = debounce(() => {
      let h = this.clientHeight;
      document.documentElement.style.setProperty('--header-height', h + 'px');
    }, 50)
    onSummaryClick(event) {
      const summaryElement = event.currentTarget;
      const detailsElement = summaryElement.parentNode;
      const parentMenuElement = detailsElement.closest('.link-container');
      const subMenuElement = detailsElement.closest('.sub-menu');
      
      const isOpen = detailsElement.hasAttribute('open');
      // if (this.querySelector('.parent-link-back--button')) {
      //   this.menu.scrollTop = 0;
      // }
      /** close others **/
      if(subMenuElement){
        subMenuElement.querySelectorAll("details").forEach((detailsOthers) => {
          if(detailsOthers!=detailsElement){
            detailsOthers.removeAttribute('open');
          }
        })
      }
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
      }, 100);
    }
    onCloseButtonClick(event) {
      event.preventDefault();
      const detailsElement = event.currentTarget.closest('details');
      this.closeSubmenu(detailsElement);
    }
    closeSubmenu(detailsElement) {
      detailsElement.classList.remove('menu-opening');
      this.closeAnimation(detailsElement);
    }
    closeAnimation(detailsElement) {
      let animationStart;

      const handleAnimation = (time) => {
        if (animationStart === undefined) {
          animationStart = time;
        }

        const elapsedTime = time - animationStart;

        if (elapsedTime < 400) {
          window.requestAnimationFrame(handleAnimation);
        } else {
          detailsElement.removeAttribute('open');
        }
      };

      window.requestAnimationFrame(handleAnimation);
    }
  }
  customElements.define('theme-header', ThemeHeader);
}

/**
 *  @class
 *  @function FullMenu
 */
if (!customElements.get('full-menu')) {
  class FullMenu extends HTMLElement {
    constructor() {
      super();

      this.submenus = this.querySelectorAll('.thb-full-menu>.menu-item-has-children:not(.menu-item-has-megamenu)>.sub-menu');
    }
    connectedCallback() {
      this.addEventListener('click', (evt) => {
        const target = evt.target.closest('.close');
        if (evt.currentTarget.contains(target)) {
          const li = target.closest('li')
          if (li) {
            li.classList.add('menu-closing')
            setTimeout(() => {
              li.classList.remove('menu-closing')
            }, 300);
          }
        }
      })
      if (!this.submenus.length) {
        return;
      }
      const _this = this;
      // resize on initial load
      document.fonts.ready.then(function() {
        window.addEventListener('resize', debounce(function() {
          _this.resizeSubMenus();
        }, 100));
      });
    }
    resizeSubMenus() {
      this.submenus.forEach((submenu) => {
        let sub_submenus = submenu.querySelectorAll(':scope >.menu-item-has-children>.sub-menu');

        sub_submenus.forEach((sub_submenu) => {
          let w = sub_submenu.offsetWidth,
            l = sub_submenu.parentElement.getBoundingClientRect().left + sub_submenu.parentElement.offsetWidth,
            total = w + l;

          if (total > window.innerWidth) {
            sub_submenu.parentElement.classList.add('left-submenu');
          } else if (sub_submenu.parentElement.classList.contains('left-submenu')) {
            sub_submenu.parentElement.classList.remove('left-submenu');
          }
        });
      });
    }
  }
  customElements.define('full-menu', FullMenu);
}



/**
 *  @class
 *  @function TabMenu
 *  @author WANG.J
 */

let menuTabs =  document.querySelectorAll('.menu-tab')

menuTabs.forEach((item,index) => {
  let lis = item.querySelectorAll("li[role]")
  let contents = item.querySelectorAll(".collection-tab-content")
  let menuTabActive =  item.querySelectorAll('li.active')
  // let as = item.querySelectorAll("li[role].has-next-menu a")
  lis.forEach((liItem,liIndex) => {
    if(!menuTabActive.length & liIndex == 0 ){
        liItem.classList.add('active')
        contents[liIndex].classList.add('active')
    }
    liItem.addEventListener('mouseenter', (event) => {
      [].forEach.call(lis, function(el) {
        el.classList.remove('active');
      });
      liItem.classList.add('active');
      if(liItem.classList.contains('has-next-menu')){
         let handle = liItem.dataset.tabindex;
        [].forEach.call(contents, function(el,i) {
          if(i == handle){
            el.classList.add("active");
          }else{
            el.classList.remove("active");
          }
        });
      }else{
        // window.location.href = liItem.querySelector("a").href
      }
    })
    // as.forEach((aItem) => {
    //   aItem.addEventListener('click', (event) => {
    //     event.preventDefault()
    //   });
    // })
  })
})


